import PropTypes from 'prop-types';
import concat from "ramda/es/concat";
import o from "ramda/es/o";
import uniq from "ramda/es/uniq";
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
export const SubmenuContext = /*#__PURE__*/ createContext({});
export const useSubmenuContext = ()=>useContext(SubmenuContext);
export const SubmenuProvider = ({ children })=>{
    const [paths, setPaths] = useState([]);
    const value = useMemo(()=>({
            paths,
            setPaths
        }), [
        paths
    ]);
    return /*#__PURE__*/ React.createElement(SubmenuContext.Provider, {
        value: value
    }, children);
};
SubmenuProvider.propTypes = {
    children: PropTypes.node
};
export const useRegisterPath = (path)=>{
    const { setPaths } = useSubmenuContext();
    useEffect(()=>{
        if (path && setPaths) {
            setPaths((paths)=>{
                if (paths.findIndex((p)=>p === path) !== -1) {
                    return paths;
                }
                return [
                    ...paths,
                    path
                ];
            });
        }
    }, [
        setPaths,
        path
    ]);
};
export const useRegisterPaths = (newPaths)=>{
    const { setPaths } = useSubmenuContext();
    useEffect(()=>{
        if (setPaths && newPaths?.length > 0) {
            setPaths((paths)=>o(uniq, concat(newPaths), paths));
        }
    }, [
        newPaths,
        setPaths
    ]);
};
